module.exports = __webpack_public_path__ + "static/media/ily-2.89d29ed0.jpg";